import React from 'react'
import { Route, Routes } from 'react-router-dom'
import QuizeAttempt from '../pages/quiz/quizeAttempt'
import QuizDetail from '../pages/quiz/quizeDetails'

const QuizContainer = () => {
  return (
    <div className=' flex items-center justify-center mx-auto mt-4'>
        <Routes>
          <Route path="/quize/attempt/*" element={<QuizeAttempt />} />
          <Route path="/quize/*" element={<QuizDetail />} />
        </Routes>
    </div>
  )
}

export default QuizContainer